import { lazy } from "react";
import type { RouteConfig } from "../config";
import { ROUTES } from "../paths";

const TasksPage = lazy(() =>
  import("@/pages/tasks/tasks-page").then((m) => ({ default: m.TasksPage })),
);

export const taskRoutes: RouteConfig[] = [
  {
    path: ROUTES.TASKS,
    component: TasksPage,
    layout: "dashboard",
    permissions: { access: "authenticated" },
  },
];
